module.exports = __webpack_public_path__ + "static/media/PreviewPlaceholderImage.c2707e51.svg";